import InputError from "@/components/input-error"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

interface PartnerAccountFormProps {
  data: {
    account: {
      name: string
    }
  }
  setData: (key: string, value: any) => void
  errors: Record<string, any>
}

// IMP-401: name-only — the Industry field was removed from the partner account
// edit page along with the dashboard's industry breakdown.
export default function PartnerAccountForm({
  data,
  setData,
  errors,
}: PartnerAccountFormProps) {
  return (
    <div className="grid gap-2">
      <Label htmlFor="name">Account name</Label>
      <Input
        id="name"
        type="text"
        className="mt-1 block w-full"
        defaultValue={data.account.name}
        placeholder="Account name"
        onChange={(e) =>
          setData("account", { ...data.account, name: e.target.value })
        }
      />
      <InputError message={(errors as any)?.name ?? undefined} />
    </div>
  )
}
